if (!customElements.get('icon-with-text-swiper')) {
  customElements.define(
    'icon-with-text-swiper',
    class IconWithTextSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        // 避免重复初始化
        if (this.swiper) return;

        const speed = this.dataset.speed || 3000;
        const swiperEl = this.querySelector('.swiper');
        if (!swiperEl) return;

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          speed: parseInt(speed, 10),
          loop: true,
          autoplay: {
            disableOnInteraction: false,
            delay: 0,
          },
          allowTouchMove: false,
        });
      }
    }
  );
}